import React, { CSSProperties, useEffect, useState } from 'react';
import { MdDelete } from 'react-icons/md';

import { useTranslations } from 'next-intl';
import NextImage from 'next/image';

import { BasicResource } from '../../types/types';

interface PropTypes {
  style?: CSSProperties;
  data: BasicResource;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  onDelete?: React.MouseEventHandler<HTMLElement> | undefined;
  className?: string;
}

function ResourceItem({ data, onClick, onDelete, className }: PropTypes) {
  const t = useTranslations();
  const [renderOnClient, setRenderOnClient] = useState(false);
  const [loadFallback, setLoadFallback] = useState(false);

  useEffect(() => {
    setRenderOnClient(true);
  }, []);

  return (
    <div
      className={`flex flex-col items-center relative title-item ${className}`}
    >
      {renderOnClient && (
        <div className="w-full h-auto bg-gray-400 rounded-md cursor-pointer img-wrapper">
          <NextImage
            className="hover:opacity-[0.4] transition-all duration-200 rounded-md"
            onClick={onClick}
            alt={
              data.type === 'movie'
                ? t('images_alts.movie_poster', { title: data.title })
                : t('images_alts.tv_poster', { title: data.title })
            }
            src={
              loadFallback || !data.poster
                ? '/assets/app/poster-fallback.jpg'
                : `https://cdn-proxy.trakio.app/t/p/w220_and_h330_face${data?.poster?.file_path}`
            }
            onError={() => {
              setLoadFallback(true);
            }}
            width={140}
            height={210}
            sizes="
              (min-width: 300px) 100px,150px
              (min-width: 768px) 140px,210px"
            unoptimized
          />

          {onDelete && (
            <button
              className="flex justify-center items-center absolute top-2 right-2 w-[30px] h-[30px] rounded-full transition-all duration-200 bg-white text-black hover:bg-gray-200"
              onClick={onDelete}
            >
              <MdDelete size={14} />
            </button>
          )}
        </div>
      )}

      {!renderOnClient && (
        <NextImage
          className="hover:opacity-[0.4] transition-all duration-200 rounded-md"
          alt={
            data.type === 'movie'
              ? t('images_alts.movie_poster', { title: data.title })
              : t('images_alts.tv_poster', { title: data.title })
          }
          src={
            data.poster
              ? `https://cdn-proxy.trakio.app/t/p/w220_and_h330_face${data?.poster?.file_path}`
              : '/assets/app/poster-fallback.jpg'
          }
          width={140}
          height={210}
          sizes="
          (min-width: 300px) 100px,150px
          (min-width: 768px) 140px,210px"
          unoptimized
        />
      )}
      <span
        className="text-white font-bold text-center cursor-pointer w-full px-2 line-clamp-2 mt-1"
        onClick={onClick}
      >
        {data.title}
      </span>
    </div>
  );
}

export default React.memo(ResourceItem);
